import axios from "axios";

const request = axios.create({
  baseURL: "https://api.atharalfarasha.com",
});

// https://api.atharalfarasha.com
export default request;
